/** Customer copy for member setup in the onboarding wizard. */

export const MEMBERS_SETUP_INTRO_COPY =
  'Add league members, assign teams, and link Twitch accounts so LSC can match live games to the right broadcasters.';

export const MEMBERS_FULL_PAGE_LINK_COPY =
  'Open the full members page for advanced invite, claim, and roster management.';
